import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CarrinhoProvider } from '../../providers/carrinho/carrinho';
import { PedidoFormPage } from '../../pages/pedido-form/pedido-form';
@Component({
  selector: 'botao-carrinho',
  templateUrl: 'botao-carrinho.html'
})
export class BotaoCarrinhoComponent {
  quantidade_itens = 0;
  
  constructor(public navCtrl: NavController, public carrinho:CarrinhoProvider) {
    this.quantidade_itens = this.carrinho.getItens().length;

    this.carrinho.eve.subscribe("carrinho:atualizar_quantidade",(quantidade)=>{
      this.quantidade_itens = quantidade;
    });
  }

  abrirCarrinho(){
    this.navCtrl.setRoot(PedidoFormPage, {});
  }
}



// WEBPACK FOOTER //
// ./src/components/botao-carrinho/botao-carrinho.ts